import { AnomalyDirection, SeasonAnomalyProduct } from '../../types/AiForecasting';

export function peak_pct(row: SeasonAnomalyProduct | undefined): number {
  const pct = row?.peak_vs_reg_pct;
  return pct != null && Number.isFinite(pct) ? Math.round(pct) : 0;
}

export function peak_direction(row: SeasonAnomalyProduct | undefined): AnomalyDirection {
  const pct = peak_pct(row);
  if (pct > 0) {
    return 'up';
  }
  if (pct < 0) {
    return 'down';
  }
  return 'flat';
}

export function peak_arrow(direction: AnomalyDirection): string {
  if (direction === 'down') {
    return '↓';
  }
  if (direction === 'up') {
    return '↑';
  }
  return '→';
}

export function peak_vs_reg_label(row: SeasonAnomalyProduct | undefined): string {
  return `${peak_arrow(peak_direction(row))} ${Math.abs(peak_pct(row))}% peak vs reg week`;
}

function format_week_avg(value: number | undefined): string | null {
  if (value == null || !Number.isFinite(value)) {
    return null;
  }
  return new Intl.NumberFormat('en-US', { maximumFractionDigits: 1 }).format(value);
}

export function peak_vs_reg_tip(
  row: SeasonAnomalyProduct | undefined,
  holiday_label: string
): string {
  const season = holiday_label || 'this season';
  const amount = Math.abs(peak_pct(row));
  const direction = peak_direction(row);
  const season_avg = format_week_avg(row?.season_week_avg);
  const off_avg = format_week_avg(row?.offseason_week_avg);
  if (season_avg && off_avg) {
    const compare =
      direction === 'flat'
        ? 'About the same as a regular week.'
        : `That is ${amount}% ${direction === 'down' ? 'below' : 'above'} a regular week.`;
    return [
      `${season} weeks for this SKU averaged ${season_avg} cases.`,
      `Ordinary non-holiday weeks averaged ${off_avg} cases.`,
      `(${season_avg} − ${off_avg}) ÷ ${off_avg} × 100 = ${amount}%`,
      compare,
    ].join('\n');
  }
  return `${season} weeks for this SKU versus this SKU’s ordinary non-holiday weeks.`;
}
